import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ParentContainor from '../../components/base/ParentContainor';
import GameScreenTopBar from '../../components/GameScreenTopBar';
import LiveGameVideoStage from '../../components/LiveGameVideoStage';
import LiveGameStatsTicker from '../../components/LiveGameStatsTicker';
import LiveGameTotalMembersPanel from '../../components/LiveGameTotalMembersPanel';
import LiveGameTriviaPanel from '../../components/LiveGameTriviaPanel';
import OptionSelector from '../../components/rap_fire/OptionSelector';
import RapFireQuestionIndexBadge from '../../components/rap_fire/RapFireQuestionIndexBadge';
import { ROUTE_ENUM } from '../../routes/RoutesConstant';
import { TEXT_LABELS } from '../../constants/TextLabelConstants';
import { FONTS } from '../../constants/Fonts';
import { IMAGE_CONSTANTS } from '../../constants/ImageConstans';
import {
  HOUSIE_GLASS_CARD_STYLE,
  HOUSIE_SIDE_PANEL_STYLE,
  RAP_FIRE_RIGHT_PANEL_STYLE,
  PAGE_OUTER_PADDING,
} from '../../constants/housieLiveStyles';

/**
 * TEMP preview — Rap Fire live game design (no auth / no MQTT).
 * Open: /preview/rapfire-game
 */
const MOCK_QUESTION = {
  questionText:
    'Hansraj Raghuwanshi ka very first song kon sa tha and realizing date kya tha?',
  options: [
    { id: 'option_1', label: 'A', text: 'Mera Bhola Hai Bhandari. (Feb 23, 2019)' },
    { id: 'option_2', label: 'B', text: 'Ganga Kinare. (Jan 12, 2018)' },
    { id: 'option_3', label: 'C', text: 'Ganga Kinare. (Jan 12, 2018)' },
    { id: 'option_4', label: 'D', text: 'Mera Bhola Hai Bhandari. (Feb 23, 2019)' },
  ],
};

const MOCK_TRIVIA = {
  entity: {
    title: 'Hansraj Raghuwanshi',
    image: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    category: { name: 'SINGER' },
    data: [
      { label: 'Date of Birth', text: '18 July 1992' },
      { label: 'Songs', text: '100+' },
      { label: 'Genre', text: 'Indian Film Pop, Indian Indie, Pop, Devotional' },
      { label: 'Subscribers', text: '10.9 million' },
    ],
  },
};

const MOCK_MEMBERS = [
  {
    userId: 'p1',
    userName: 'QuizWarrior',
    profilePic: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    gameState: ['correct', 'pending', 'pending', 'pending', 'pending'],
  },
  {
    userId: 'p2',
    userName: 'Olivia de Pro',
    profilePic: IMAGE_CONSTANTS.V2_HEADER_AVATAR || IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    gameState: ['correct', 'pending', 'pending', 'pending', 'pending'],
  },
  {
    userId: 'p3',
    userName: 'RapStar99',
    profilePic: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    gameState: ['wrong', 'pending', 'pending', 'pending', 'pending'],
  },
  {
    userId: 'p4',
    userName: 'NeonNinja',
    profilePic: IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER,
    gameState: ['pending', 'pending', 'pending', 'pending', 'pending'],
  },
];

const RapFireGameDesignPreview = () => {
  const navigate = useNavigate();
  const [selectedOptionId, setSelectedOptionId] = useState(null);

  return (
    <ParentContainor
      route={ROUTE_ENUM.SELECT_GAME}
      parentContainorStyle={{ justifyContent: 'flex-start' }}
      isShowHeader={false}
      isBreadcrumbVisible={false}
      showCopyRightText
      showBlurredBg
      padding={PAGE_OUTER_PADDING}
    >
      <div
        style={{
          display: 'flex',
          flex: 1,
          width: '100%',
          minHeight: 640,
          flexDirection: 'column',
          alignItems: 'center',
          padding: '0 0 40px',
          boxSizing: 'border-box',
          gap: 0,
        }}
      >
        <GameScreenTopBar
          title={
            TEXT_LABELS.RAP_FIRE_WELCOME_TITLE_BRAND ||
            TEXT_LABELS.RAP_FIRE_LOBBY_BRAND_TITLE
          }
          onBack={() => navigate(ROUTE_ENUM.SELECT_GAME.routePath)}
        />

        <div
          style={{
            display: 'flex',
            flex: 1,
            width: 'calc(100% - 40px)',
            marginLeft: 20,
            marginRight: 20,
            flexDirection: 'row',
            gap: 24,
            justifyContent: 'space-between',
            alignItems: 'stretch',
            minHeight: 720,
            position: 'relative',
            boxSizing: 'border-box',
          }}
        >
          <div style={HOUSIE_SIDE_PANEL_STYLE}>
            <LiveGameTriviaPanel triviaData={MOCK_TRIVIA} />
          </div>

          <div
            style={{
              ...HOUSIE_GLASS_CARD_STYLE,
              borderRadius: 20,
              border: 'none',
              boxShadow: 'none',
              display: 'flex',
              flexDirection: 'column',
              flex: '1 1 0',
              width: 0,
              minWidth: 0,
              minHeight: 640,
              padding: '20px',
              overflow: 'visible',
              position: 'relative',
              boxSizing: 'border-box',
            }}
          >
            <LiveGameVideoStage>
              <img
                src={
                  IMAGE_CONSTANTS.V2_REVAMPED_RAPFIRE_HERO_BG ||
                  IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER
                }
                alt=""
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              />
            </LiveGameVideoStage>

            <div
              data-node-id="18423:5131"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                gap: 20,
                width: '100%',
                marginTop: 16,
              }}
            >
              <div
                data-node-id="18423:5092"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 17,
                  width: '100%',
                  minWidth: 0,
                }}
              >
                <RapFireQuestionIndexBadge current={1} total={5} />
                <p
                  data-node-id="18423:5093"
                  style={{
                    margin: 0,
                    flex: 1,
                    minWidth: 0,
                    fontFamily: FONTS.INTER_BOLD,
                    fontWeight: 700,
                    fontSize: 20,
                    lineHeight: '32px',
                    letterSpacing: 0.8,
                    color: '#003',
                    wordBreak: 'break-word',
                  }}
                >
                  {MOCK_QUESTION.questionText}
                </p>
              </div>

              <OptionSelector
                options={MOCK_QUESTION.options}
                selectedOptionId={selectedOptionId}
                onSelectOption={(option) => setSelectedOptionId(option?.id ?? null)}
              />
            </div>
          </div>

          <div style={RAP_FIRE_RIGHT_PANEL_STYLE}>
            <LiveGameTotalMembersPanel members={MOCK_MEMBERS} showQuestionProgress />
          </div>
        </div>

        <LiveGameStatsTicker
          items={[
            '200+ Played RapFire today',
            '26.5 M RapCoins Credited to Player',
            '200 Playing in Corporate Room',
          ]}
        />
      </div>
    </ParentContainor>
  );
};

export default RapFireGameDesignPreview;
